import React, { useRef, useState } from 'react';
import { Label } from '@nooz-optics/nooz-components-lib';
import { IShopItem } from '../../../../../utils/types/contentful';
import { withLocale } from '../../../../../utils/hocs';
import { Image } from '../../../Media/Image/index';
import { Link } from '../../../Elements/Link';
import { ShopItemVariantImages } from '../VariantImage';

export const ShopProductItemMiniCard = withLocale(
  ({
    label,
    onClick,
    product,
    colorVariants,
    selectedVariant,
    selectedSize,
  }: IShopItem) => {
    const carousel = useRef();
    const variant = colorVariants?.find((v) => {
      if (selectedVariant?.size) {
        return (
          selectedVariant?.color?.shopifyKey?.toLowerCase() ===
            v?.color?.shopifyKey?.toLowerCase() &&
          selectedVariant?.size?.value === v?.size?.value
        );
      } else {
        return (
          selectedVariant?.color?.shopifyKey?.toLowerCase() ===
          v?.color?.shopifyKey?.toLowerCase()
        );
      }
    });

    return (
      <Link slug={product.slug}>
        <button
          type='button'
          className='flex flex-col w-full justify-between cursor-pointer relative'
          onClick={onClick}>
          <div
            ref={carousel}
            className='group flex transition duration-500 overflow-hidden w-full relative'>
            {/* Product Image */}
            <ShopItemVariantImages
              product={product}
              variants={colorVariants}
              parentRef={carousel}
              selectedVariant={selectedVariant}
              selectedSize={selectedSize}
            />
          </div>
          <div className='flex-row w-full relative justify-end pt-1'>
            <div className='w-full flex flex-col justify-start pr-3 mt-2'>
              <Label
                align='text-left'
                weight='normal'
                size='xl'
                text={label?.text}
                color={{ classname: 'primary' }}
                truncate
              />
              <Label
                align='text-left'
                weight='normal'
                size='sm'
                text={selectedVariant?.color?.text}
                color={{ classname: 'gray-700' }}
                truncate
              />
            </div>
          </div>
        </button>
      </Link>
    );
  }
);
